import { OnInit } from '@angular/core';
import { GenericService } from "../../../services/generic.service";
var UcdComponent = /** @class */ (function () {
    function UcdComponent(_genericService) {
        this._genericService = _genericService;
    }
    Object.defineProperty(UcdComponent.prototype, "initData", {
        set: function (value) {
            this.compData = value;
        },
        enumerable: true,
        configurable: true
    });
    UcdComponent.prototype.ngOnInit = function () { };
    return UcdComponent;
}());
export { UcdComponent };
